export default "__VITE_ASSET__ClFvzaee__"